import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SiteHeaderUtils from '../utils/SiteHeaderUtils';
import SiteHeaderActionCreator from '../actions/SiteHeaderActionCreator';
import ContentStore from '../stores/InternetBankingContentStore';
import AccountsStore from '../stores/AccountsStore';

const compose =
  (...fns) =>
  (val) =>
    _.reduce(fns, (result, fn) => fn(result), val);

const hasAlert = (item) => ['activateYourSecurityToken'].includes(item.id);
const hasOverdraftCalculator = (item) => item.id === 'overdraftCostCalculator';
const titleCss = (alert) =>
  `c-site-subnav__title ${alert ? 'c-site-subnav__alert' : ''}`;

const getTitleCss = compose(hasAlert, titleCss);

class HeaderLinkComponent extends Component {
  constructor(props) {
    super(props);
    this.headerClick = this.headerClick.bind(this);
  }

  getSubHeadingItem(item) {
    if (AccountsStore.isYouthAccount() && item.id === 'tools') {
      return null;
    }
    const subMenuItem = SiteHeaderUtils.getSubHeadings(
      item.id,
      this.props.exclusionList
    );

    const items = _.reduce(
      subMenuItem,
      (acc, item) =>
        this.props.checkMenuItemCondition(item.id)
          ? [...acc, this.getLinkMenuItem(item)]
          : acc,
      []
    );

    if (items.length === 0) return <div />;

    return (
      <li className="c-site-subnav__item c-site-subnav__item--other">
        <strong className="c-site-subnav__group">{item.title}</strong>
        <ul>{items}</ul>
      </li>
    );
  }

  getLinkMenuItem(item) {
    const onclick = (e) => {
      this.headerClick(item);
      e.preventDefault();
    };
    return (
      <li
        key={item.id}
        className="c-site-subnav__item c-site-subnav__item--other"
      >
        <button
          data-test-id={`link-more-${item.id}`}
          className=" c-site-subnav__link"
          name={item.title}
          onClick={onclick}
        >
          <span className={getTitleCss(item)}>
            {item.title}&nbsp;
            {item.id === 'securemessage' && this.props.count > 0 && (
              <span className="c-site-subnav__badge badge badge--message">
                {this.props.count}
                <span aria-live="polite" className="u-visually-hidden">
                  unread messages
                </span>
              </span>
            )}
          </span>
          <span
            aria-hidden="true"
            className="c-site-subnav__icon icon icon-swipe-right"
          />
        </button>
      </li>
    );
  }
  headerClick(item) {
    if (hasOverdraftCalculator(item)) {
      const modalConfig = {
        displayLeavePopup: true,
        title: ContentStore.get('PopupHeading'),
        body: `${ContentStore.get('HelpPopupContent1')} ${ContentStore.get(
          'HelpPopupContent2'
        )}`,
        secondaryButtonText: 'Proceed',
        primaryButtonText: 'Stay on Page',
      };
      SiteHeaderActionCreator.setModalConfig(modalConfig);
      SiteHeaderActionCreator.toBeSelectedNavItem(item);
      setTimeout(() => {
        this.props.headerClick(item, false);
      }, 150);
    } else {
      this.props.headerClick(item, false);
    }
  }
  render() {
    const { linkItem } = this.props;
    if (linkItem.subHeading) {
      return this.getSubHeadingItem(linkItem);
    } else {
      return this.getLinkMenuItem(linkItem);
    }
  }
}

HeaderLinkComponent.propTypes = {
  linkItem: PropTypes.object,
  headerClick: PropTypes.func,
  checkMenuItemCondition: PropTypes.func,
  count: PropTypes.number,
  exclusionList: PropTypes.array,
};

HeaderLinkComponent.defaultProps = {
  exclusionList: [],
};

export default HeaderLinkComponent;
